import axios from 'axios';
import config from './config';

const api = axios.create({
  baseURL: config.API_BASE,
  timeout: 20000
});

api.interceptors.request.use((request) => {
  const token = localStorage.getItem('idToken');
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
});

const params = (query = {}) => ({
  params: Object.fromEntries(Object.entries(query).filter(([, value]) => value !== '' && value !== undefined && value !== null))
});

export const studentsApi = {
  list: (query) => api.get('/students', params(query)).then((res) => res.data),
  get: (id) => api.get(`/students/${id}`).then((res) => res.data),
  create: (payload) => api.post('/students', payload).then((res) => res.data),
  update: (id, payload) => api.put(`/students/${id}`, payload).then((res) => res.data),
  remove: (id) => api.delete(`/students/${id}`).then((res) => res.data),
  exams: (id) => api.get(`/students/${id}/exams`).then((res) => res.data),
  addExam: (payload) => api.post('/students/exams', payload).then((res) => res.data)
};

export const employeesApi = {
  list: (query) => api.get('/employees', params(query)).then((res) => res.data),
  get: (id) => api.get(`/employees/${id}`).then((res) => res.data),
  create: (payload) => api.post('/employees', payload).then((res) => res.data),
  update: (id, payload) => api.put(`/employees/${id}`, payload).then((res) => res.data),
  remove: (id) => api.delete(`/employees/${id}`).then((res) => res.data)
};

export const teachersApi = {
  list: (query) => api.get('/teachers', params(query)).then((res) => res.data),
  get: (id) => api.get(`/teachers/${id}`).then((res) => res.data),
  create: (payload) => api.post('/teachers', payload).then((res) => res.data),
  update: (id, payload) => api.put(`/teachers/${id}`, payload).then((res) => res.data),
  remove: (id) => api.delete(`/teachers/${id}`).then((res) => res.data)
};

export const auditApi = {
  create: (payload) => api.post('/auditlogs', payload).then((res) => res.data),
  list: (query) => api.get('/auditlogs', params(query)).then((res) => res.data),
  timeline: (targetId) => api.get(`/timeline/${targetId}`).then((res) => res.data)
};

export const documentsApi = {
  createUpload: (payload) => api.post('/documents', payload).then((res) => res.data),
  list: (ownerId) => api.get(`/documents/${ownerId}`).then((res) => res.data)
};

export const analyticsApi = {
  get: () => api.get('/analytics').then((res) => res.data)
};

export const verificationApi = {
  get: (type, id) => api.get(`/verify/${type}/${id}`).then((res) => res.data)
};

export const teacherApi = {
  dashboard: () => api.get('/teacher/dashboard').then((res) => res.data),
  students: (query) => api.get('/teacher/students', params(query)).then((res) => res.data),
  attendance: (query) => api.get('/teacher/attendance', params(query)).then((res) => res.data),
  saveAttendance: (payload) => api.post('/teacher/attendance', payload).then((res) => res.data),
  updateAttendance: (payload) => api.put('/teacher/attendance', payload).then((res) => res.data),
  marks: (query) => api.get('/teacher/marks', params(query)).then((res) => res.data),
  saveMarks: (payload) => api.post('/teacher/marks', payload).then((res) => res.data),
  updateMarks: (payload) => api.put('/teacher/marks', payload).then((res) => res.data),
  auditLogs: (query) => api.get('/teacher/audit-logs', params(query)).then((res) => res.data),
  reports: (query) => api.get('/teacher/reports', params(query)).then((res) => res.data),
  notifications: () => api.get('/teacher/notifications').then((res) => res.data)
};

export default api;
